/**
 * Recuperación de contraseña de operador: `POST /api/v1/operators/forgot|reset`. Sin sesión (como
 * `login` en `./session.ts`): no hay token que adjuntar todavía.
 */

import { z } from "zod";

import { rawRequest } from "./http";

/** Siempre responde 202, exista o no el correo; el cuerpo no importa a quien llama. */
export async function requestOperatorPasswordReset(email: string): Promise<void> {
  await rawRequest("/api/v1/operators/forgot", { method: "POST", body: { email } }, z.unknown());
}

export async function resetOperatorPassword(input: { token: string; password: string }): Promise<void> {
  await rawRequest("/api/v1/operators/reset", { method: "POST", body: input }, z.unknown());
}
